import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "Quicksand",
    h1: {
      fontFamily: "Quicksand, sans-serif",
      fontWeight: "bold",
      fontSize: 36
    },
    h2: {
      fontSize: 28,
      fontWeight: "bold"
    },
    h3: {
      fontSize: 20,
      fontWeight: "bold"
    },
    subtitle1: {
      fontSize: 18,
      fontWeight: "bold"
    },
    body: {
      fontSize: 16
    },
    body2: {
      fontSize: 14
    }
  },
  palette: {
    primary: {
      main: '#42C6BC',
      contrastText: '#fff',
    },
    secondary: {
      main: '#ffb029',
      contrastText: '#fff',
    },
  },
  shadows: [
    "none",
    "0px 1px 4px 1px rgba(0, 0, 0, 0.05)"
  ]
});

export default theme;